module.exports = __webpack_public_path__ + "static/img/class2.f1d5d48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/class2.png
// module id = Bvkq
// module chunks = 0